<template>
  <div class="post-dashboard-map">
    <div
      v-for="group in groupEntries"
      :key="group.name"
      class="dashboard-card"
    >
      <div class="card-name">{{ group.name }}</div>
      <div class="card-total">{{ group.total }}</div>
      <div class="card-label">TOTAL ASSETS</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AssetMapPostDashboard',
  data() {
    return {
      locationData: {},
      updateInterval: 10,
      intervalId: null,
    };
  },
  computed: {
    company() {
      return localStorage.getItem('company') || '';
    },
    groupEntries() {
      return Object.entries(this.locationData).map(([name, data]) => ({
        name,
        total: data.total || 0,
      }));
    }
  },
  methods: {
    async fetchLocationData() {
      try {
        const company = this.company;
        const response = await axios.get('/api/location-all', {
          params: { company }
        });
        this.locationData = response.data;
      } catch (error) {
        console.error('Error fetching location data:', error);
        this.locationData = {};
      }
    },
    startFetching() {
      this.fetchLocationData();
      if (this.intervalId) clearInterval(this.intervalId);
      this.intervalId = setInterval(() => {
        this.fetchLocationData();
      }, this.updateInterval * 1000);
    }
  },
  mounted() {
    this.startFetching();
  },
  beforeUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
};
</script>

<style scoped>
.post-dashboard-map {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  width: 100%;
  height: 100%;
}

.dashboard-card {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 110px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.card-name {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
}

.card-total {
  font-size: 26px;
  color: #1e73ff;
  font-weight: 700;
  margin-bottom: 4px;
}

.card-label {
  font-size: 10px;
  letter-spacing: 0.5px;
  color: #888;
}

@media screen and (max-width: 1200px) {
  .post-dashboard-map {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 768px) {
  .post-dashboard-map {
    grid-template-columns: 1fr;
  }
}
</style>

